import { render, staticRenderFns } from "./VaeBadge.vue?vue&type=template&id=bc8dc3e2&scoped=true&"
import script from "./VaeBadge.vue?vue&type=script&lang=ts&"
export * from "./VaeBadge.vue?vue&type=script&lang=ts&"
import style0 from "./VaeBadge.vue?vue&type=style&index=0&id=bc8dc3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8dc3e2",
  null
  
)

export default component.exports